// Author lidongxu
// Date 2024-02-22 10:33:31

class SithMesStoolPrApplicationIndirectPurchaseDetail {
constructor({
        id = null,
        applicationNo = '',
        department = '',
        projectNo = '',
        wbsNo = '',
        glAccountNo = '',
        fixedAssetNo = '',
        name = '',
        specification = '',
        quantity = '',
        unit = '',
        expectDeliveryDate = '',
        buyer = '',
        newToolFlag = '',
        buyReason = '',
        oldToolFlag = '',
        oldToolDestination = '',
        remark = ''}
= {}) {
    this.id = id;
    this.applicationNo = applicationNo;
    this.department = department;
    this.projectNo = projectNo;
    this.wbsNo = wbsNo;
    this.glAccountNo = glAccountNo;
    this.fixedAssetNo = fixedAssetNo;
    this.name = name;
    this.specification = specification;
    this.quantity = quantity;
    this.unit = unit;
    this.expectDeliveryDate = expectDeliveryDate;
    this.buyer = buyer;
    this.newToolFlag = newToolFlag;
    this.buyReason = buyReason;
    this.oldToolFlag = oldToolFlag;
    this.oldToolDestination = oldToolDestination;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesStoolPrApplicationIndirectPurchaseDetail();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applicationNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.applicationNo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'department',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.department',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.projectNo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'wbsNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.wbsNo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'glAccountNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.glAccountNo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'fixedAssetNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.fixedAssetNo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'name',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.name',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'specification',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.specification',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'quantity',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.quantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'unit',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.unit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'expectDeliveryDate',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.expectDeliveryDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'buyer',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.buyer',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'newToolFlag',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.newToolFlag',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'buyReason',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.buyReason',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'oldToolFlag',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.oldToolFlag',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'oldToolDestination',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.oldToolDestination',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    applicationNoFilter : '',
    departmentFilter : '',
    projectNoFilter : '',
    wbsNoFilter : '',
    glAccountNoFilter : '',
    fixedAssetNoFilter : '',
    nameFilter : '',
    specificationFilter : '',
    quantityFilter : '',
    unitFilter : '',
    expectDeliveryDateRteFilter : '',
    expectDeliveryDateLteFilter : '',
    buyerFilter : '',
    newToolFlagFilter : '',
    buyReasonFilter : '',
    oldToolFlagFilter : '',
    oldToolDestinationFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'applicationNoFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.applicationNo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'departmentFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.department',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectNoFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.projectNo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbsNoFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.wbsNo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'glAccountNoFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.glAccountNo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'fixedAssetNoFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.fixedAssetNo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.name',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'specificationFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.specification',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'quantityFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.quantity',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'unitFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.unit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'expectDeliveryDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.expectDeliveryDateRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'expectDeliveryDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.expectDeliveryDateLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'buyerFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.buyer',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'newToolFlagFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.newToolFlag',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'buyReasonFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.buyReason',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'oldToolFlagFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.oldToolFlag',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'oldToolDestinationFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.filter.oldToolDestination',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'applicationNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.applicationNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'department',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.department',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.projectNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbsNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.wbsNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'glAccountNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.glAccountNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'fixedAssetNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.fixedAssetNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'name',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'specification',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.specification',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'quantity',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'unit',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.unit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'expectDeliveryDate',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.expectDeliveryDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'buyer',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.buyer',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'newToolFlag',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.newToolFlag',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'buyReason',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.buyReason',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'oldToolFlag',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.oldToolFlag',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'oldToolDestination',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.oldToolDestination',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPrApplicationIndirectPurchaseDetail.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesStoolPrApplicationIndirectPurchaseDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
